import * as React from "react";
import Button from "../components/Button";
import Typography from "../components/Typography";
import ProductHeroLayout from "./ProductHeroLayout";
import backgroundImage from "../../assets/IMG_3781.jpg";

export default function ProductHero() {
  return (
    <ProductHeroLayout
      sxBackground={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundColor: "#7fc7d9", // Average color of the background image.
        backgroundPosition: "center",
      }}
    >
      {/* Increase the network loading priority of the background image. */}
      <img
        style={{ display: "none" }}
        src={backgroundImage}
        alt="increase priority"
      />
      <Typography color="inherit" align="center" variant="h4" sx={{ mb: 3 }}>
        STEAM教育家
      </Typography>
      <Typography color="inherit" align="center" variant="h2" marked="center">
        鈴木美苗
      </Typography>
      <Typography
        color="inherit"
        align="center"
        variant="h5"
        sx={{ mb: 4, mt: { sx: 4, sm: 10 } }}
      >
        あなたの学びに明かりを灯す
      </Typography>
      <Button
        color="secondary"
        variant="contained"
        size="large"
        component="a"
        href="https://forms.gle/E79EUiQEsWrbzZV4A"
        target="_blank"
        sx={{ minWidth: 200 }}
      >
        お問い合わせ
      </Button>
      <Typography variant="body2" color="inherit" sx={{ mt: 2 }}>
        講演等のご依頼は下記をご覧ください
      </Typography>
    </ProductHeroLayout>
  );
}
